const skillsData = [
  "React 19",
  "Nx Monorepo",
  "ShadeCN",
  "HTML5",
  "JavaScript",
  "UX/UI Research",
  "TypeScript",
  "TailwindCSS",
  "GraphQL",
  "REST API",
  "CI/CD",
  "Angular",
  "MaterialUI",
  "Storybook",
  "Figma",
  "A11y",
  "Swagger",
  "Agile/Jira",
];

export default skillsData;
